import { filter, map, mergeMap, mapTo } from 'rxjs/operators'
import * as ReduxObservable from 'redux-observable'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Router from '../../router'
import * as App from '../../app'
import * as Common from '../common'
import { of, EMPTY } from 'rxjs'
import queryString from 'query-string'

// Epic to handle route navigation
export const onEnterEpic: ReduxObservable.Epic = (action$, state$, { history }: any) =>
  action$.ofType(Router.ON_ENTER).pipe(
    filter((action: any) => history.location.pathname.startsWith(Constants.URL_HOME)),
    map(({ params }: any) => {
      const guid = queryString.parse(history.location.search).guid as string;

      if (guid && params.community_identifier) {
        // Store URL params and fetch both user topics and suggested topics
        // Note: The API will handle filtering based on hide_recommended_topics configuration
        return of(
          { type: Constants.INITIALIZE_FROM_URL, query: { guid, community_identifier: params.community_identifier } },
          Request.requestActionCreator<Request.RequestOptions>(Constants.FETCH_USER_TOPICS)({
            method: 'GET',
            public: true,
            url: `/topic_preference/my_topics/${params.community_identifier}/${guid}`,
          }),
          Request.requestActionCreator<Request.RequestOptions>(Constants.FETCH_SUGGESTED_TOPICS)({
            method: 'GET',
            public: true,
            url: `/topic_preference/suggest_topics/${params.community_identifier}/${guid}`,
          })
        );
      }

      return EMPTY;
    }),
    mergeMap(actions => actions)
  );

// Wait for configurations to be ready before rendering
export const configurationsReady: ReduxObservable.Epic = (action$, state$, {history}) =>
  action$.ofType(
    Request.successConstant(Constants.FETCH_USER_TOPICS), 
    Request.errorConstant(Constants.FETCH_USER_TOPICS),
    Request.successConstant(Constants.FETCH_SUGGESTED_TOPICS),
    Request.errorConstant(Constants.FETCH_SUGGESTED_TOPICS)
  ).pipe(
    filter(() => history.location.pathname.startsWith(Constants.URL_HOME)),
    filter(() => {
      return state$.value.topicPreferences.configurations.length > 0
    }),
    mapTo(App.readyForRender())
  );

// Wait for topic data to be ready before rendering (when configurations already loaded)
export const topicDataReady: ReduxObservable.Epic = (action$, state$, {history}) =>
  action$.ofType(Request.successConstant(Common.FETCH_CONFIGURATION), Request.errorConstant(Common.FETCH_CONFIGURATION))
  .pipe(
    filter(() => history.location.pathname.startsWith(Constants.URL_HOME)),
    filter(() => state$.value.topicPreferences && (
      state$.value.topicPreferences.topics.length > 0 || 
      state$.value.topicPreferences.recommendedTopics.length > 0 ||
      !state$.value.topicPreferences.isLoadingTopics
    )),
    mapTo(App.readyForRender())
  );

// Handle successful submission
export const onSuccessfulSubmissionEpic: ReduxObservable.Epic = (action$, store, { history }) =>
  action$.ofType(Request.successConstant(Constants.SUBMIT_TOPIC_PREFERENCES))
    .pipe(
      map(() => Router.push(history.location.pathname))
    );

export const epic = ReduxObservable.combineEpics(
  onEnterEpic,
  configurationsReady,
  topicDataReady,
  onSuccessfulSubmissionEpic
)